const FIGURE_REGEX = /<figure>([\s\S]*?)<\/figure>/gi
const PAGE_HEADER_REGEX = /<!--\s*PageHeader\s*=\s*["']([^"']+)["']\s*-->/gi
const PAGE_NUMBER_BREAK_REGEX =
  /<!--\s*PageNumber\s*=\s*["']([^"']+)["']\s*-->\s*<!--\s*PageBreak\s*-->/gi

function escapeHtml(value: string): string {
  return value.replace(/[<>&"]/g, (character) => {
    switch (character) {
      case "<":
        return "&lt;"
      case ">":
        return "&gt;"
      case "&":
        return "&amp;"
      case '"':
        return "&quot;"
      default:
        return character
    }
  })
}

function formatFigure(match: string, caption: string): string {
  const trimmedCaption = caption.trim()
  if (!trimmedCaption) {
    return ""
  }
  return `\n<div class="page-header-figure">${escapeHtml(trimmedCaption)}</div>\n\n`
}

function formatPageHeader(match: string, header: string): string {
  const trimmedHeader = header.trim()
  if (!trimmedHeader) {
    return ""
  }
  return `\n<div class="page-header-note">${escapeHtml(trimmedHeader)}</div>\n\n`
}

function formatPageBreak(match: string, label: string): string {
  const trimmedLabel = label.trim()
  const labelMarkup = trimmedLabel
    ? `<span>${escapeHtml(trimmedLabel)}</span>`
    : `<span>Page Break</span>`
  return `\n<div class="page-break">${labelMarkup}</div>\n\n`
}

function collapseExtraLines(value: string): string {
  return value.replace(/\n{3,}/g, "\n\n")
}

/**
 * Normalizes Document Intelligence markup so that translator answers render as
 * expected inside markdown.
 */
export function formatDocumentIntelligenceContent(content: string): string {
  if (!content) {
    return content
  }

  let formatted = content

  formatted = formatted.replace(FIGURE_REGEX, formatFigure)
  formatted = formatted.replace(PAGE_HEADER_REGEX, formatPageHeader)
  formatted = formatted.replace(PAGE_NUMBER_BREAK_REGEX, formatPageBreak)

  return collapseExtraLines(formatted).trimStart()
}
